import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * useGroupListStore
 *
 * 단순화된 그룹 스토어 - React Query 마이그레이션 후
 *
 * 상태:
 * - currentGroupId: 현재 선택된 그룹 ID (UI 상태만 관리)
 *
 * 참고:
 * - list와 storedList는 React Query가 관리합니다 (useInfiniteGroupListQuery, useInfiniteStorageListQuery)
 * - persist 제거 (currentGroupId는 휘발성 UI 상태)
 */

export interface GroupListStoreState {
  currentGroupId: string | null;
  setCurrentGroupId: (groupId: string | null) => void;
}

export const useGroupListStore = create<GroupListStoreState>()(
  devtools(
    (set) => ({
      currentGroupId: null,
      setCurrentGroupId: (groupId: string | null) =>
        set({ currentGroupId: groupId }),
    }),
    { name: "GroupListStore" }
  )
);
